module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"errors":{"inPerson":"Address or location is required","searching":"There was an error finding this business. Try again."},"addressHelpText":"Select an address or location"}}')
  delete Component.options._Ctor
}
